import React, { FC } from 'react'

import { IconPrivacyProps } from './IconPrivacy.types'
import * as Styled from './styles/IconPrivacy.style'

import { nonThemeableRules } from '../../ruleSet'

const IconPrivacy: FC<IconPrivacyProps> = ({
  size = nonThemeableRules.defaultSize as number as IconPrivacyProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconPrivacyProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='m115.25 142-9.58-59.6-4.06-26.8a32 32 0 1 0-43.15.07L44.76 142a4.05 4.05 0 0 0 0 .64A17.49 17.49 0 0 0 62.12 160h35.77a17.5 17.5 0 0 0 17.41-17.36 4 4 0 0 0-.05-.64zm-17.37 10H62.13a9.47 9.47 0 0 1-9.42-9.13l14-88.17a4 4 0 0 0-1.49-3.78 24 24 0 1 1 29.62-.06 4 4 0 0 0-1.48 3.74l4.4 29 9.52 59.27a9.48 9.48 0 0 1-9.4 9.13z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconPrivacy
